'use client';
import { useTheme } from 'next-themes';
import { useTranslation } from 'react-i18next';
import { ExtProject } from './page';
import { reactMarkdownConfig } from '@/lib/utils/strapi';
import ReactMarkdown from 'react-markdown';
import { Button, Link } from '@nextui-org/react';
import { useRouter } from 'next/navigation';

export default function ProjectPage({ project }: { project: ExtProject }) {
  // const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  // console.log(JSON.stringify(project, undefined, 2));
  const router = useRouter();
  return (
    <section className="container mx-auto py-20 lg:px-6 px-3">
      <ReactMarkdown className="prose max-w-full " {...reactMarkdownConfig}>
        {project[0].attributes.text}
      </ReactMarkdown>
      <div className="mt-3">
        <Button
          size="lg"
          variant="flat"
          as={Link}
          color="primary"
          showAnchorIcon
          // href="/#portfolio"
          onPress={() => {
            router.push(`/#portfolio`);
          }}
        >
          {t('back')}
        </Button>
      </div>
    </section>
  );
}
